import React from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

const LOGO_COLOR = '/yellow-black-logo.svg';
const LOGO_FOOTER = '/Rhutechsolutionslogo%20dark.svg';

const sizeStyles = {
  bar: css`
    height: clamp(90px, 11vw);
    width: auto;
    max-width: min(600px, 75vw);
    min-height: 50px;
    filter: drop-shadow(0 8px 24px rgba(0, 0, 0, 0.15));
  `,
  drawer: css`
    height: clamp(80px, 15vw, 100px);
    width: auto;
    max-width: min(450px, 100vw);
    filter: drop-shadow(0 6px 20px rgba(0, 0, 0, 0.12));
  `,
  footer: css`
    height: 70px;
    width: auto;
    max-width: min(380px, 100vw);
    filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.1));
  `,
  static: css`
    height: clamp(100px, 13vw, 150px);
    width: auto;
    max-width: min(620px, 100vw);
    filter: drop-shadow(0 10px 30px rgba(0, 0, 0, 0.18));
  `,
};

const LogoLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  line-height: 0;
  text-decoration: none;
  min-width: 0;
  flex-shrink: 0;

  &:focus-visible {
    outline: 2px solid #0e6b3c;
    outline-offset: 4px;
    border-radius: 8px;
  }
`;

const LogoImg = styled.img`
  display: block;
  object-fit: contain;
  object-position: left center;
  flex-shrink: 0;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  ${(p) => sizeStyles[p.$size] || sizeStyles.bar}
  ${(p) => p.$height != null && `height: ${p.$height}px !important;`}
  ${(p) => p.$maxWidth && `max-width: ${p.$maxWidth} !important;`}
`;

const Logo = ({
  to = '/',
  size = 'bar',
  height,
  maxWidth,
  className,
  variant,
}) => {
  const resolvedSize =
    variant === 'footer' ? 'footer' : variant === 'static' ? 'static' : size;
  const isFooter = resolvedSize === 'footer';
  const src = isFooter ? LOGO_FOOTER : LOGO_COLOR;

  return (
    <LogoLink to={to} className={className} aria-label="Rhutech Solutions — Home">
      <LogoImg
        src={src}
        alt="Rhutech Solutions"
        $size={resolvedSize}
        $height={height}
        $maxWidth={maxWidth}
        loading="eager"
        decoding="async"
      />
    </LogoLink>
  );
};

export default Logo;
